import { client, request, apiHeaders } from "./_base";

const endpoint = "sailingschedule";

export type SailingScheduleType = {
    id: number;
    file_name: string;
    content: string;
    user_id: number;
    created_at: Date;
};

export type ParsedSailingScheduleType = SailingScheduleType & {
    content: Record<string, any[]>;
    sheetNames: string[];
    sheets: number;
};

export const sailingschedule = client<SailingScheduleType>(endpoint, (item: SailingScheduleType) => ({
    ...item,
}));

export const uploadSailingSchedule = async (fileBase64: string, fileName: string, clearExisting = true) => {
    const content = JSON.stringify({ fileBase64, fileName, clearExisting });
    const result = await request(`${endpoint}/upload`, {
        method: "POST",
        headers: apiHeaders(content),
        body: content,
    });
    const resp = await result.json();
    if (result.status == 500) {
        throw resp;
    }
    return resp;
};

export type SailingScheduleDataType = {
    id: number;
    port_id: number | null;
    port: string | null;
    port_of_loading: string | null;
    etd: Date | null;
    vessel: string | null;
    voyage: string | null;
    line: string | null;
    line_service: string | null;
    stacks: string | null;
    created_at: Date;
    updated_at: Date | null;
};

export type SailingScheduleResponse = {
    data: SailingScheduleDataType[];
    headers: Record<string, string>;
    lastUploadedAt: Date | null;
};

export const getSailingScheduleData = async (): Promise<SailingScheduleResponse> => {
    const result = await request(`${endpoint}/all`, {
        method: "GET",
        headers: apiHeaders(),
    });

    if (result.status === 500) {
        throw await result.json();
    }

    const response = await result.json();
    return {
        data: response.data || [],
        headers: response.headers || {},
        lastUploadedAt: response.lastUploadedAt ? new Date(response.lastUploadedAt) : null,
    };
};